import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { BREAKING_NEWS_PATH, BREAKING_NEWS_IMAGE } from '../BreakingNews';
import MainBlockLayout from '../../components/MainBlockLayout';
import './MediaAndNews.css';

const IFRAME_PERMISSIONS =
    'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

function MainBlock() {
    const news = useSelector(state => state.newsAndMedia.news);
    const media = useSelector(state => state.newsAndMedia.media);

    // Videos shown in the grid. To add one, add a line here and its link in
    // store/slices/NewsAndMedia/data/newsAndMedia.js. vertical=true for Instagram reels.
    const videos = [
        { src: media.youtube1, title: "St Mary's Ukrainian Saturday school" },
        { src: media.youtube2, title: 'Case Study: St Marys Ukrainian School, London' },
        { src: media.youtube3, title: "Kate Middleton's Ukrainian Choir Pays Tribute To Queen Elizabeth With Royal Carol Concert | Lorraine" },
        { src: media.vimeo1, title: 'school activities' },
        { src: media.istagram1, title: 'kalush', vertical: true },
    ];

    return (
        <div className="mediaPage">
            <div className="mediaHero">
                <h2><Trans ns="navigation" i18nKey="media news" /></h2>
                <p><Trans i18nKey="media_intro" /></p>
            </div>

            <h3 className="mediaHeading">{t('St Marys in News')}</h3>
            <div className="newsGrid">
                {/* Latest school news first: links to the hidden article page */}
                <div className="newsCard">
                    <img src={BREAKING_NEWS_IMAGE} alt="" loading="lazy" />
                    <div className="newsCardBody">
                        <p className="newsCardTitle">{t('breaking_title')}</p>
                        <Link className="newsCardLink" to={BREAKING_NEWS_PATH}>
                            {t('Read more')}
                        </Link>
                    </div>
                </div>
                {Object.keys(news).map((key) => (
                    <div className="newsCard" key={key}>
                        <img src={news[key].source} alt="" loading="lazy" />
                        <div className="newsCardBody">
                            <p className="newsCardTitle">{t(news[key].name)}</p>
                            <a className="newsCardLink" href={news[key].linkToPage} target="_blank" rel="noreferrer">
                                {t('Read more')}
                            </a>
                        </div>
                    </div>
                ))}
            </div>

            <h3 className="mediaHeading">{t('St Marys Videos')}</h3>
            <div className="videoGrid">
                {videos.map((video) => (
                    <div className={`videoBox ${video.vertical ? 'videoBoxVertical' : ''}`} key={video.title}>
                        <iframe
                            src={video.src}
                            title={video.title}
                            allow={IFRAME_PERMISSIONS}
                            allowFullScreen
                            loading="lazy"
                        />
                    </div>
                ))}
            </div>

            <h3 className="mediaHeading">{t('St Marys Podcasts')}</h3>
            <div className="podcastBox">
                <iframe
                    title="The Morning Break with Holly King-Mand 05-05-22: Supporting Ukrainian Refugees in Our Schools"
                    height="160"
                    src={media.podbean}
                />
            </div>
        </div>
    );
}

export default MainBlockLayout(MainBlock);
